export enum ClearMarginModifiers {
    CLEAR_MARGIN = 'sh-clear-margin',
    CLEAR_MARGIN_HORIZONTAL = 'sh-clear-margin-horizontal',
    CLEAR_MARGIN_VERTICAL = 'sh-clear-margin-vertical',
    CLEAR_MARGIN_TOP = 'sh-clear-margin-top',
    CLEAR_MARGIN_TOP_IMPORTANT = 'sh-clear-margin-top__important',
    CLEAR_MARGIN_RIGHT = 'sh-clear-margin-right',
    CLEAR_MARGIN_BOTTOM = 'sh-clear-margin-bottom',
    CLEAR_MARGIN_LEFT = 'sh-clear-margin-left'
}
